<template>
    <ModalContent immersive @close="hideModal({ result: false })">
        <template slot="content">

            <div class="profile-offer-hero">
                <svg class="profile-offer-art" viewBox="0 0 240 150" aria-hidden="true" focusable="false">
                    <ellipse cx="120" cy="87" rx="105" ry="58" fill="#eeebff" />
                    <rect x="62" y="18" width="113" height="115" rx="12" fill="white" stroke="#d9d2f1" transform="rotate(-6 118 75)" />
                    <circle cx="95" cy="53" r="13" fill="#b6a0ed" />
                    <path d="M75 83c0-23 40-23 40 0" fill="#b6a0ed" />
                    <path d="M127 48h27m-27 13h20M83 100h65m-65 12h45" stroke="#9b8dc2" stroke-width="5" stroke-linecap="round" />
                    <rect x="22" y="86" width="62" height="43" rx="7" fill="#f4cf96" />
                    <path d="m25 91 28 20 28-20" fill="none" stroke="#b97c36" stroke-width="3" stroke-linejoin="round" />
                    <circle cx="181" cy="102" r="25" fill="#327b65" stroke="white" stroke-width="6" />
                    <path d="m170 102 8 8 15-17" fill="none" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="m195 33 3 8 8 3-8 3-3 8-3-8-8-3 8-3Z" fill="#b6a0ed" />
                </svg>
                <p class="profile-offer-success">La fiche de {{ params.customer.name }} est créée</p>
                <h3 class="text-h5 mb-2">Et si votre client la complétait ?</h3>
                <p class="text-body-2 mb-0">Coordonnées, facturation, livraison : demandez-lui de vérifier ses informations.</p>
            </div>
            <ol class="profile-offer-steps">
                <li><span class="profile-offer-number">1</span><div><b>Vous préparez l’email</b><p>Vérifiez le destinataire et le message avant l’envoi.</p></div></li>
                <li><span class="profile-offer-number">2</span><div><b>Il complète sa fiche</b><p>Depuis un lien sécurisé ou son espace Safetee.</p></div></li>
                <li><span class="profile-offer-number">3</span><div><b>Vous êtes informé</b><p>Sa confirmation met sa fiche à jour.</p></div></li>
            </ol>
            <details class="profile-offer-details">
                <summary>Le lien, les relances et le compte Safetee</summary>
                <p>Le lien est valable 14 jours, avec deux relances incluses. Après confirmation, votre client pourra créer son compte et rejoindre votre organisation sur Safetee. Vous en serez informé.</p>
            </details>
            <p class="profile-offer-reassurance">Rien n’est envoyé à cette étape. Vous pourrez aussi le faire plus tard depuis sa fiche.</p>
            <div class="profile-offer-actions">
                <Button text="Préparer la demande" @click="hideModal({ result: true })" />
            </div>
        </template>
    </ModalContent>
</template>
<script>
import GlobalMixins from '@/mixins/global';
export default {
    width: 680,
    mixins: [GlobalMixins],
    props: { params: { type: Object, required: true } },
};
</script>
<style scoped>
.profile-offer-hero { text-align: center; padding: 24px 8px 20px; }
.profile-offer-art { width: 200px; height: 125px; display: block; margin: 0 auto 8px; }
.profile-offer-success { color: #286650; font-size: 13px; font-weight: 600; margin-bottom: 8px; overflow-wrap: anywhere; }
.profile-offer-steps { list-style: none; padding: 0; margin: 0 0 16px; display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 12px; }
.profile-offer-steps li { padding: 16px 12px; background: #f7f6fc; border-radius: 12px; }
.profile-offer-number { display: inline-flex; align-items: center; justify-content: center; width: 28px; height: 28px; border-radius: 50%; background: #e7e0fa; color: #533492; font-weight: 700; margin-bottom: 10px; }
.profile-offer-steps li:nth-child(2) { background: #fff7ed; }
.profile-offer-steps li:nth-child(2) .profile-offer-number { background: #f7dfbc; color: #82551c; }
.profile-offer-steps li:nth-child(3) { background: #eff7f3; }
.profile-offer-steps li:nth-child(3) .profile-offer-number { background: #d5eade; color: #286650; }
.profile-offer-steps b { display: block; font-size: 14px; }
.profile-offer-steps p { font-size: 13px; line-height: 1.5; margin: 6px 0 0; color: #5d596c; }
.profile-offer-details { font-size: 13px; color: #5d596c; }
.profile-offer-details summary { cursor: pointer; padding: 6px 0; }
.profile-offer-details p { margin: 8px 0; }
.profile-offer-reassurance { font-size: 12px; color: #5d596c; margin: 12px 0 0; }
.profile-offer-actions { width: 100%; display: flex; flex-wrap: wrap; justify-content: center; gap: 12px; padding: 16px 0; }
@media (max-width: 600px) {
    .profile-offer-steps { grid-template-columns: 1fr; gap: 8px; }
    .profile-offer-steps li { display: flex; align-items: flex-start; gap: 12px; padding: 12px; }
    .profile-offer-number { flex-shrink: 0; margin-bottom: 0; }
    .profile-offer-art { width: 160px; height: 100px; }
    .profile-offer-actions > * { width: 100%; margin: 0 !important; }
}
</style>
